export default "varying vec2 vUv;\n\nvoid main() {\n  float y = fract(vUv.y * 20.);\n  float opacity = 0.1;\n  gl_FragColor = vec4(1., 1.0, 1.0, opacity);\n}\n"